import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogOverlay,
} from '@/components/ui/dialog';

interface ModalProps {
  open: boolean;
  onOpenChange?: (open: boolean) => void;
  title?: string;
  children: React.ReactNode;
  description?: string;
  style?: string | boolean;
  closeBtn?: React.ReactNode;
  bgBlur?: boolean;
  fullWidth?: boolean;
  headerClassName?: string;
}

export function Modal({
  open,
  onOpenChange,
  title,
  description,
  children,
  style,
  closeBtn,
  bgBlur = false,
  fullWidth,
  headerClassName = 'bg-table-head',
}: ModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {bgBlur && <DialogOverlay className="bg-primary-foreground backdrop-blur-[5px]" />}

      <DialogContent
        className={`max-w-xl bg-white p-0 data-[state=open]:animate-modal-in data-[state=closed]:animate-modal-out ${style || ''} [&>button.absolute]:hidden`}
      >
        {(title || closeBtn) && (
          <DialogHeader
            className={`sticky top-0 z-10 flex flex-row items-center justify-between border-b rounded-t-md  border-green3 ${headerClassName} p-3 text-black`}
          >
            <div>
              <DialogTitle className="text-xl font-semibold">{title}</DialogTitle>

              {description && (
                <DialogDescription className="text-gray">{description}</DialogDescription>
              )}
            </div>

            {closeBtn && (
              <div onClick={() => onOpenChange?.(false)} className="cursor-pointer flex-shrink-0">
                {closeBtn}
              </div>
            )}
          </DialogHeader>
        )}

        {/* Only this part scrolls */}
        <div className="max-h-[calc(80dvh-70px)] overflow-y-auto p-4">{children}</div>
      </DialogContent>
    </Dialog>
  );
}
